import Scriba from 'react-scriba';

export class DataLotCommercial {

    static _chargementInformationLotEspaceDeVente = (idOperation, idLotCommercial, idLot) => {
        const objet = { idOperation, idLotCommercial, idLot };
        const url = "api/Get/GetDetailVente";
        const paramPost = Scriba.fetch().createParameterPost(objet)
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementLotCommercial(idOperation, idLotCommercial) {
        let objet = {
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial
        };

        var url = "api/Get/GetLotCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementLotCommercialById(idLotCommercial) {
        let objet = {
            "idLotCommercial": idLotCommercial
        };

        var url = "api/Get/GetLotCommercialSimplifie";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDeLaNatureEtPerimetreDuLotCommercial(idLotCommercial, idOperation) {
        let objet = {
            "idLotCommercial": idLotCommercial,
            "idOperation": idOperation
        };

        let url = "api/Get/GetNatureEtPerimetreDuLotCommercial";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _importLotsCommerciaux = (lotsCommerciaux) => {
        const objet = { lotsCommerciaux };
        const url = "api/MAJDonnees/EnregistrementImportLotsCommerciaux";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementHistoriqueLotCommercial(idLotCommercial) {
        let objet = {
            "idLotCommercial": idLotCommercial
        }

        var url = "api/Fiche/FicheLotCommercialHistorique";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementLotCommercial(lotCommercial) {
        let objet = {
            "lotCommercial": lotCommercial
        }

        var url = "api/MAJDonnees/EnregistrementLotCommercial";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionLotsCommerciaux(listLotsCommerciaux) {
        let objet = {
            "lotsCommerciaux": listLotsCommerciaux
        }

        var url = "api/MAJDonnees/SuppressionLotsCommerciauxEtLots";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionLotsCommerciauxVides(idOperation, idLotCommercial) {
        let objet = { idOperation, idLotCommercial }

        var url = "api/MAJDonnees/SuppressionLotsCommerciauxVide";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onMiseEnVenteLotsCommerciaux(listLots, actifVente) {
        let objet = {
            "listLots": listLots,
            "actifVente": actifVente
        }

        var url = "api/MAJDonnees/EnregistrementMiseEnVenteLotsCommerciaux";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementLotCommercialVide() {
        let objet = {};

        var url = "api/Liste/ListeLotsCommerciauxVides";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}